import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const TheExperiment = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from('.exp-fade', {
        y: 30,
        opacity: 0,
        duration: 0.6,
        stagger: 0.1,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 75%',
          toggleActions: 'play none none reverse',
        },
      });
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="home-section-tight">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Context */}
          <div>
            <span className="exp-fade home-kicker mb-4 block">The Studies</span>
            <h2 className="exp-fade text-4xl md:text-5xl font-bold text-white mb-6 leading-tight tracking-tight">
              Seven ways to see<br/>physics happen.
            </h2>
            <p className="exp-fade home-body mb-6">
              Each study focuses on a real detector principle or a real physical idea. Scattering through matter, energy deposition in tissue, Cherenkov ring formation, magnetic momentum measurement, transition radiation identification, cosmic muon imaging, and precision spin precession  -  each one lets the learner change conditions, run events, and inspect the outcome.
            </p>
            <p className="exp-fade home-body mb-8">
              The physics is simplified but scientifically meaningful. Materials have radiation lengths and densities. Particles have different masses. Energy loss, curvature, and decay are modeled as physical processes rather than decorative animations.
            </p>
            <div className="exp-fade flex flex-wrap items-center gap-3 text-sm font-mono text-white/30">
              <span className="home-chip">MCS</span>
              <span className="home-chip">Bragg Peak</span>
              <span className="home-chip">Cherenkov</span>
              <span className="home-chip">Spectrometer</span>
              <span className="home-chip">TRD</span>
              <span className="home-chip">Tomography</span>
              <span className="home-chip">Muon g-2</span>
            </div>
          </div>

          {/* Right: Photo */}
          <div className="exp-fade relative group">
            <div className="absolute -inset-1 bg-cyan-400/20 rounded-lg blur opacity-0 group-hover:opacity-100 transition duration-500 group-hover:shadow-[0_0_30px_rgba(34,211,238,0.2)]"></div>
            <div className="relative overflow-hidden rounded-lg transition-all duration-500 group-hover:-translate-y-2">
              <img
                src="/images/pic2.jpg"
                alt="Student using the simulator on a laptop"
                className="w-full h-auto rounded-lg object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TheExperiment;
